import api from './api';

export type LogAction =
  | 'register'
  | 'login'
  | 'logout'
  | 'init_pass'
  | 'modify_auth'
  | 'init_pass_by_admin'
  | 'remove_member'
  | 'publish'
  | 'report_view'
  | 'role_change'
  | 'admin_access'
  | 'export'
  | 'password_reset_request'
  | 'password_reset'
  | 'impersonate'
  | 'impersonate_end'
  | 'write_complete'
  | 'write_cancel'
  | 'approve';

export const LOG_ACTION_LABELS: Record<LogAction, string> = {
  register: '회원가입',
  login: '로그인',
  logout: '로그아웃',
  init_pass: '비밀번호 초기화',
  modify_auth: '권한변경',
  init_pass_by_admin: '관리자 비번 초기화',
  remove_member: '회원삭제',
  publish: '리포트 Publish',
  report_view: '보고서 조회',
  role_change: '역할변경',
  admin_access: '관리자 접근',
  export: '내보내기',
  password_reset_request: '비번 재설정 요청',
  password_reset: '비번 재설정',
  impersonate: '권한 전환 보기',
  impersonate_end: '권한 전환 보기 종료',
  write_complete: '보고서 작성완료',
  write_cancel: '작성완료 취소',
  approve: '보고서 승인(일괄 발행)',
};

export interface Log {
  id: number;
  email: string;
  action: LogAction;
  details?: string;
  timestamp: string;
}

export interface LogFilter {
  action?: LogAction | '';
  email?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
}

export interface LogsResponse {
  logs: Log[];
  total: number;
}

export const logsService = {
  async getAll(filter: LogFilter = {}): Promise<LogsResponse> {
    const params: Record<string, any> = {
      page: filter.page ?? 1,
      limit: filter.limit ?? 50,
    };
    if (filter.action) params.action = filter.action;
    if (filter.email) params.email = filter.email;
    if (filter.startDate) params.startDate = filter.startDate;
    if (filter.endDate) params.endDate = filter.endDate;

    const { data } = await api.get<LogsResponse>('/logs', { params });
    return data;
  },
};
